
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface UsePublicCharactersParams {
  speciesFilter: string;
  roleFilter: string;
  searchTerm: string;
}

export const usePublicCharacters = ({
  speciesFilter,
  roleFilter,
  searchTerm,
}: UsePublicCharactersParams) => {
  return useQuery({
    queryKey: ["public-characters", speciesFilter, roleFilter, searchTerm],
    queryFn: async () => {
      let query = supabase
        .from("characters")
        .select("*")
        .eq("status", "published")
        .order("featured", { ascending: false })
        .order("display_order", { ascending: true })
        .order("name", { ascending: true });

      // Apply search filter
      if (searchTerm.trim()) {
        query = query.or(
          `name.ilike.%${searchTerm}%,description.ilike.%${searchTerm}%,personality.ilike.%${searchTerm}%,teaching_focus.ilike.%${searchTerm}%,special_talents.ilike.%${searchTerm}%`
        );
      }

      // Apply species filter
      if (speciesFilter !== "all") {
        query = query.eq("species", speciesFilter);
      }

      // Apply role filter
      if (roleFilter !== "all") {
        query = query.eq("role", roleFilter);
      }

      const { data, error } = await query;

      if (error) {
        console.error("Error fetching public characters:", error);
        throw error;
      }

      return data || [];
    },
  });
};
